/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { EXPORT_FILE, downloadExcelFile } from './utils';
import { DownloadFileHandlerPorps } from './utils';

import './NotificationModal.css';

import { Grid, Box, Typography } from '@mui/material';
import CustomModal from '../CustomModal/CustomModal';
import ModalHeader from '../CustomModal/ModalHeader';
import { fonts, themes } from '../../themes/themes';
import { RichEditor } from '../../../components/inputs/RichEditor';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  notificationViewData: any;
  trans?: any;
}

const NotificationViewModalPresenter = ({
  isModalOpen,
  closeModal,
  notificationViewData,
  trans,
}: ModalProps) => {
  const Message = notificationViewData?.row
    ? notificationViewData?.row?.message
    : notificationViewData?.notifiable_type;
  const Attachement = notificationViewData?.row
    ? notificationViewData?.row?.attachment
    : notificationViewData?.attachments;

  const handleDowload = ({
    attachment,
    name = 'excel',
  }: DownloadFileHandlerPorps) => {
    if (attachment.includes(EXPORT_FILE)) {
      downloadExcelFile(attachment, name);
    }
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="auto"
    >
      <ModalHeader
        modal={{ modal_title: trans('Notification Details') }}
        closeModal={closeModal}
      />

      <Grid
        container
        style={{
          marginTop: '35px',
        }}
      >
        <Grid item xs={12} className="left-grid">
          <Grid container style={{ padding: '10px' }}>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                {trans('Messages')}
              </Typography>
              {Message && (
                <div style={{ height: '100%' }}>
                  <RichEditor readOnly={true} value={Message} />
                </div>
              )}

              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  color: themes.blackDefault,
                  fontWeight: 'bold',
                  textAlign: 'center',
                  marginTop: '1em',
                }}
              >
                {Attachement ? (
                  <p
                    className="download-csv"
                    onClick={() => {
                      handleDowload({
                        attachment: Attachement,
                        name: notificationViewData?.row?.name,
                      });
                    }}
                  >
                    {trans('Click here to download')}
                  </p>
                ) : (
                  ''
                )}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          {' '}
        </Grid>
      </Grid>
      <Box style={{ marginTop: '35px' }} />
    </CustomModal>
  );
};

export default NotificationViewModalPresenter;
